// Copyright (c) 2021, 37.78 Tecnologia Ltda. All rights reserved.

const MuiTextField = {
  styleOverrides: {
    root: {
      "& p": {
        marginLeft: "2px",
      },
    },
  },
};

export default MuiTextField;
